module.exports = __webpack_public_path__ + "img/welding-9.9d991d70.jpg";